import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ClientType from "../../../Types/Entites/ClientType";
import axios from "axios";
import { RootState } from "../../store";
import {
  ConditionAchatType,
  ConditionClientType,
  ConditionProduitType,
  GratuiteType,
  RemiseType,
} from "../../../Types/Entites/RemiseType";

/**
 * create clients function
 * @private
 */
export const createRemise = createAsyncThunk(
  "remises/saveRemise",
  async (data: RemiseType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveRemise", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const updateRemiseApi = createAsyncThunk(
  "remises/updateRemiseApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put("remises/updateRemiseApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const updateGratuiteApi = createAsyncThunk(
  "remises/updateGratuiteApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put("remises/updateGratuiteApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

/**
 * Get list of remise by orgId
 * @public
 */
export const findRemisesByOrganisation = createAsyncThunk(
  "remises/findRemises",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`remises/findRemises/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);
export const deleteRemise = createAsyncThunk(
  "remises/deleteRemise",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`remises/deleteRemise/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

/**
 * Get list of remise bu filtre
 * @public
 */
export const findRemisesByFiltre = createAsyncThunk(
  "remises/findRemisesByFiltre",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`remises/findRemises`, data);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

/**
 * create remise function
 * @private
 */
export const createGratuite = createAsyncThunk(
  "remises/createGratuite",
  async (data: GratuiteType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/createGratuite", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

/**
 * Get list of clients.
 * @public
 */
export const findGratuitesByOrganisations = createAsyncThunk(
  "remises/findGratuite",
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`remises/findGratuite/${id}`);
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

/**
 * create clients function
 * @private
 */
export const createConditionAchat = createAsyncThunk(
  "remises/saveConditionAchat",
  async (data: ConditionAchatType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveConditionAchat", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
/**
 * create clients function
 * @private
 */
export const createConditionClient = createAsyncThunk(
  "remises/saveConditionClient",
  async (data: ConditionClientType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveConditionClient", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

/**
 * create remise produit
 * @private
 */
export const saveRemiseArticleApi = createAsyncThunk(
  "remises/saveRemiseArticleApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveRemiseArticleApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
/**
 * create condition produit
 * @private
 */
export const saveConditionProduitRemiseApi = createAsyncThunk(
  "remises/saveConditionProduitRemiseApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveConditionProduitRemiseApi", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
/**
 * create clients function
 * @private
 */
export const createConditionProduit = createAsyncThunk(
  "remises/saveConditionProduit",
  async (data: ConditionProduitType, { rejectWithValue }) => {
    try {
      const response = await axios.post("remises/saveConditionProduit", data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
/**
 * create clients function
 * @private
 */
export const checkDiscountsByArticle = createAsyncThunk(
  "remises/checkDiscountsByArticle",
  async (article_id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `remises/checkDiscountsByArticle/${article_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const getRemiseApplicable = createAsyncThunk(
  "remises/remisesCheck",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `remises/remisesCheck/${data.article_id}/${data.client_id}/${data.achat}/${data.qte}/${data.prix}/${data.organisation_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const getTestRemiseApplicable = createAsyncThunk(
  "remises/remisesCheck",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`remises/testremiseCheck`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const getProgramFideliteApplicable = createAsyncThunk(
  "remises/fideliteCheck",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`remises/fideliteCheck`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const getGratuitesApplicable = createAsyncThunk(
  "remises/gratuiteCheck",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`remises/gratuiteCheck`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const allCartRemises = createAsyncThunk(
  "remises/remiseCheck",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(`remises/remiseCheck`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const findListRemiseFiltresApi = createAsyncThunk(
  "remises/findListRemiseFiltresApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `remises/findListRemiseFiltresApi`,
        data
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const getRemiseConditionsApi = createAsyncThunk(
  "remises/getRemiseConditionsApi",
  async (idRemise: any, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `remises/getRemiseConditionsApi/${idRemise}`);
      return response;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const DesactiverRemiseApi = createAsyncThunk(
  "remises/DesactiverRemiseApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(`remises/DesactiverRemiseApi`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
export const appliquerRemiseConditionApi = createAsyncThunk(
  "remises/appliquerRemiseConditionApi",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(`remises/appliquerRemiseConditionApi`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);
interface RemiseState {
  ListRemises: RemiseType[];
  ListRemiseFiltre: RemiseType[];
  listGratuites: GratuiteType[];
  currentpage: null;
  totalPages: null;
}

const initialState: RemiseState = {
  ListRemises: [],
  ListRemiseFiltre: [],
  listGratuites: [],
  currentpage: null,
  totalPages: null,
};

export const RemiseState = createSlice({
  name: "remiseSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createRemise.fulfilled, (state, action) => {
      state.ListRemises.splice(0, 0, action.payload.data);
    });

    builder.addCase(updateRemiseApi.fulfilled, (state, action) => {
      const findindex = state.ListRemises.findIndex(
        (item) => item._id === action.payload.data.updateremise._id
      );
      if (findindex !== -1) {
        state.ListRemises[findindex] = action.payload.data.updateremise;
      }
    });
    builder.addCase(DesactiverRemiseApi.fulfilled, (state, action) => {
      console.log("ction.payload", action.payload);

      const findindex = state.ListRemiseFiltre.findIndex(
        (item) => item._id === action.payload.data._id
      );
      console.log("findindex", findindex);

      if (findindex !== -1) {
        state.ListRemiseFiltre[findindex] = action.payload.data;
      }
    });
    builder.addCase(deleteRemise.fulfilled, (state, action) => {
      state.ListRemises = state.ListRemises.filter(
        (i) => i._id !== action.payload.data._id
      );
    });

    builder.addCase(updateGratuiteApi.fulfilled, (state, action) => {
      const findindex = state.listGratuites.findIndex(
        (item) => item._id === action.payload.data.updatgGratuite._id
      );
      if (findindex !== -1) {
        state.listGratuites[findindex] = action.payload.data.updatgGratuite;
      }
    });

    builder.addCase(findRemisesByOrganisation.fulfilled, (state, action) => {
      return {
        ...state,
        ListRemises: action.payload,
      };
    });
    builder.addCase(findRemisesByFiltre.fulfilled, (state, action) => {
      return {
        ...state,
        ListRemises: action.payload.data,
        currentpage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
      };
    });
    builder.addCase(createGratuite.fulfilled, (state, action) => {
      state.listGratuites.splice(0, 0, action.payload.data);
    });
    builder.addCase(findGratuitesByOrganisations.fulfilled, (state, action) => {
      return {
        ...state,
        listGratuites: action.payload,
      };
    });

    builder.addCase(findListRemiseFiltresApi.fulfilled, (state, action) => {
      return {
        ...state,
        ListRemiseFiltre: action.payload,
      };
    });
  },
});

export const ListRemises = (state: RootState) => state.remise.ListRemises;
export const ListRemiseFiltre = (state: RootState) =>
  state.remise.ListRemiseFiltre;

export const ListGratuite = (state: RootState) => state.remise.listGratuites;
export const currentpage = (state: RootState) => state.remise.currentpage;
export const totalPages = (state: RootState) => state.remise.totalPages;
export default RemiseState.reducer;
